import request from '@/plugins/request';

/**
 * 获取产品列表
 * @param {Object} params - 请求参数，如页码、分类ID等
 * @returns {Promise} - 返回Promise对象
 */
export function getProductList(params) {
  return request({
    url: '/fronted/products/list',
    method: 'get',
    params
  });
}
/**
 * 获取产品列表
 * @param {Object} params - 请求参数，如页码、分类ID等
 * @returns {Promise} - 返回Promise对象
 */
export function getFooterProductList(params) {
  return request({
    url: '/fronted/product/list',
    method: 'get',
    params
  });
}
/**
 * 获取产品分类列表
 * @param {Object} params - 请求参数，如页码、每页数量等
 * @returns {Promise} - 返回Promise对象
 */
export function getProductCategories(params = { pageNum: 1, pageSize: 10, dictType: 'product_category' }) {
  return request({
    url: '/fronted/dict/data/list',
    method: 'get',
    params
  });
}

/**
 * 获取产品详情
 * @param {string|number} id - 产品ID
 * @returns {Promise} - 返回Promise对象
 */
export function getProductDetail(id) {
  return request({
    url: `/fronted/products/${id}`,
    method: 'get'
  });
}

/**
 * 根据分类ID获取产品列表
 * @param {string|number} categoryId - 分类ID
 * @param {Object} params - 其他请求参数
 * @returns {Promise} - 返回Promise对象
 */
export function getProductsByCategory(categoryId, params) {
  return request({
    url: '/fronted/products/list',
    method: 'get',
    params: { ...params, categoryId }
  });
} 